<template>
    <form v-bind:method="baseMethod" v-bind:action="action" :class="formClass"
          v-on:submit.prevent="sendForm" :id="formEdit">
        <input name="_method" type="hidden" :value="method" v-if="(method != 'POST' && method != 'GET')">
        <div class="m-portlet__body">
            <ul class="nav nav-tabs  m-tabs-line" role="tablist">
                <li class="nav-item m-tabs__item" v-for="(value, key, index) in panels" v-bind:key="key">
                    <a class="nav-link m-tabs__link show" v-bind:class="{'active' : (index == 0)}"
                       data-toggle="tab" v-bind:href="'#m_tabs_6_'+slugify(key)" role="tab" aria-selected="true">
                        {{key}}
                    </a>
                </li>
            </ul>
            <div class="tab-content">
                <div class="tab-pane show" v-bind:class="{'active' : (index == 0)}"
                     v-bind:id="'m_tabs_6_'+slugify(key)" role="tabpanel" v-for="(value, key, index) in panels"
                     v-bind:key="key">
                    <div class="row" v-for="(row_value, row_key) in getRow(value)" v-bind:key="row_key"
                         v-if="row_value.break != 1">
                        <div v-for="(value4, key4) in row_value" :class="getClass(value4)"
                             v-bind:key="key4">
                            <FormGroupComponent
                                    v-for="item in getElements(value4)"
                                    :key="item.name"
                                    v-bind:value="getValue(item.name)"
                                    v-bind:label="item.label"
                                    v-bind:placeholder="item.placeholder"
                                    v-bind:id="item.id"
                                    v-bind:helpText="item.helpText"
                                    v-bind:name="item.name"
                                    v-bind:type="item.type"
                                    v-bind:has-danger="item.hasDanger"
                                    v-bind:error-message="errorMessage"
                                    v-bind:viewStyle="item.viewStyle"
                                    v-bind:inputClass="item.class"
                                    v-bind:options="item.options">
                            </FormGroupComponent>
                        </div>
                    </div>
                    <div v-else>
                        <hr/>
                    </div>
                </div>
            </div>
        </div>
        <div class="m-portlet__foot">
            <div class="row align-items-center">
                <div class="col-lg-6 m--valign-middle">
                    {{$t('Actions')}}
                </div>
                <div class="col-lg-6 m--align-right">
                    <button type="submit" class="btn btn-brand">
                        {{$t('Submit')}}
                    </button>
                    <span class="m--margin-left-10">
                                        {{$t('or')}}
                                        <router-link :to="listLink" class="m-link m--font-bold">
                                            {{$t('Cancel')}}
                                        </router-link>
                                    </span>
                </div>
            </div>
        </div>
    </form>
</template>

<script>
import FormGroupComponent from './form/FormGroupComponent'

export default {
  name: 'BaseForm',
  components: {FormGroupComponent},
  props: ['panels', 'method', 'baseMethod', 'action', 'formClass', 'moduleName', 'listLink', 'model'],
  data () {
    return {
      postBody: '',
      formEdit: 'formEdit',
      errorMessage: []
    }
  },
  methods: {
    slugify: function (val) {
      let p = val.split(' ').join('_')
      return p
    },
    getRow: function (items) {
      let arr = []

      items.map(function (value, key) {
        if (value.row !== undefined) {
          arr.push(value.row)
        } else {
          arr.push({'break': 1})
        }
      })

      return arr
    },
    getElements: function (items) {
      return items[this.getClass(items)]
    },
    getClass: function (item) {
      for (let it in item) {
        return it
      }
    },
    getValue: function (elem) {
      if (this.model && this.model[elem]) {
        return this.model[elem]
      }
      return ''
    },
    sendForm: function () {
      let form = document.getElementById('formEdit')
      let formData = new FormData(form)

      this.$http.post(this.action, formData, {
        'headers': {
          'Authorization': 'Bearer ' + localStorage.getItem('token'),
          'language': this.$store.state.loading.language
        }
      }).then(res => {
        if (res.data && res.data.data !== 'undefined') {
          self.role = res.data.data
          this.errorMessage = []
          if (this.method === 'POST') {
            this.$router.push(this.listLink)
          }
        } else {
          this.errorMessage = res.response.data.errors
        }
      }).catch(res => {

      })
    }
  },
  mounted: function () {
    let self = this
    this.$http
      .get(process.env.API_URL + '/api/v1/admin/module-builder/show/' + this.moduleName, {
        'headers': {
          'Authorization': 'Bearer ' + localStorage.getItem('token'),
          'language': this.$store.state.loading.language
        }
      }).then(res => {
        self.panels = res.data.data.inputs
      }).catch(res => {

      })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/core/BaseForm.vue